import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { ASSISTANT_API_URL } from 'src/constants';
import { customHeaders } from 'src/store/shared/rtkHeaders/helpers';

import { ReauthBaseQuery } from '@skynet/data-auth-api';

const customBaseQuery = fetchBaseQuery({
  baseUrl: ASSISTANT_API_URL,
  // @ts-expect-error to avoid the use of `getState as () => RootState`
  prepareHeaders: (headers, { getState }) => customHeaders(headers, getState),
});

export const rtkExchangesApi = createApi({
  reducerPath: 'ExchangesApi',
  tagTypes: ['Exchanges', 'Exchange', 'Regions', 'Region'],
  baseQuery: ReauthBaseQuery(customBaseQuery),
  endpoints: (_builder) => ({}),
});
